import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { getCardImage } from "../BillingInformation-types";
import AuthEditButton from "./AuthEditButton";
import { buildResponsiveTableData, renderResponsiveTableComponents, } from "../../../Shared/components/ResponsiveTable";
import { CREDIT_CARD_COLUMN_METADATA } from "./";
export const buildCreditCardTable = (options) => {
    const { cards, usingStripeOrTap, setupIntentLoading = false, token, selectedCard, authorizeUrl, onEditCard, onRemoveCard, onPrimaryToggle, setSelectedCard, excludeColumns = [], } = options;
    const columnConfig = CREDIT_CARD_COLUMN_METADATA;
    // Row mapper function that transforms PaymentMethod into table row using pure descriptors
    const mapCreditCardToRow = (card, helpers) => {
        var _a, _b;
        // Create action buttons as descriptors
        const actionButtons = [];
        // Edit button (conditional)
        if (usingStripeOrTap) {
            actionButtons.push(helpers.createIconButton("edit", // Using string icon name instead of JSX
            () => onEditCard(card.id), `Edit card ending in ${card.card.last4}`, "primary"));
        }
        // Auth edit button (conditional) - this needs special handling since it's a custom component
        if (!setupIntentLoading && !usingStripeOrTap && token) {
            actionButtons.push(helpers.createCustomComponent("AuthEditButton", {
                card,
                formToken: token,
                selectedCard,
                authorizeUrl,
                setupIntentLoading,
                setSelectedCard,
            }));
        }
        // Remove button (conditional)
        if (!card.isPrimary) {
            actionButtons.push(helpers.createIconButton("delete", // Using string icon name
            () => onRemoveCard(card), `Remove card ending in ${card.card.last4}`, "default"));
        }
        return {
            cardImage: helpers.createImage(getCardImage(card.card.brand), `${card.card.brand} card`),
            last4: card.card.last4,
            expiration: `${(_a = card === null || card === void 0 ? void 0 : card.card.expiration) === null || _a === void 0 ? void 0 : _a.month}/${(_b = card === null || card === void 0 ? void 0 : card.card.expiration) === null || _b === void 0 ? void 0 : _b.year}`,
            isPrimary: helpers.createSwitch(card.isPrimary, () => (!card.isPrimary ? onPrimaryToggle(card.id) : null), card.isPrimary, `Set ${card.card.last4} as primary payment method`),
            actions: helpers.createStack("row", 1, actionButtons),
        };
    };
    // Build the complete table structure using pure approach
    const tableData = buildResponsiveTableData({
        data: cards,
        columnConfig,
        rowMapper: mapCreditCardToRow,
        excludeColumns,
    });
    // Render with component registry for custom components and icon registry
    return renderResponsiveTableComponents(tableData, {
        componentRegistry: {
            AuthEditButton: AuthEditButton,
        },
        iconRegistry: {
            edit: EditIcon,
            delete: DeleteForeverIcon,
        },
    });
};
